import { useQuery } from '@tanstack/react-query';

import { get } from '@helpers/common/axios.helper';

import { CHAIN_ID } from '@constants/common/chain.constants';
import { SortDestination } from '@constants/common/common.constants';
import {
  API_DEX_FACTORIES,
  API_FARMS_LIST,
  API_FARMS_POOL_V3_LIQUIDITY_CHART,
} from '@constants/vaults/api.constants';
import { FarmSortBy } from '@constants/vaults/common.constants';

import { DexFactoriesDto } from '@dto/vaults/farms.dto';
import {
  FarmV3LiquidityChartDto,
  FarmsDto,
} from '@dto/vaults/vault-factory.dto';

export const getDexFactories = (chainIds: number[]) =>
  get<DexFactoriesDto>(API_DEX_FACTORIES, { chainIds });

export const useGetDexFactories = (chainIds: number[]) =>
  useQuery<DexFactoriesDto>({
    queryKey: [API_DEX_FACTORIES, chainIds],
    queryFn: () => getDexFactories(chainIds),
    retry: false,
  });

// ----------------------------------------------getFarms-----------------------------------------------------

export type FarmsParams = {
  sortBy: FarmSortBy;
  sortDirection: SortDestination;
  vaultFactoryIds: string[];
  dexFactoryIds: number[];
  types: string[];
  search: string | undefined;
  chainIds?: CHAIN_ID[];
};

export const getFarms = (params: FarmsParams): Promise<FarmsDto> =>
  get<FarmsDto>(API_FARMS_LIST, {
    ...params,
    staging: import.meta.env.VITE_STAGE,
  });

export const useFarms = (params: FarmsParams) =>
  useQuery({
    queryKey: [API_FARMS_LIST, params],
    queryFn: () =>
      getFarms({
        ...params,
      }),
    retry: false,
    refetchOnMount: false,
    enabled: !!params,
  });

// ----------------------------------------------getLiquidityChartData-----------------------------------------------------//

export const getLiquidityChartData = (farmId: number) =>
  get<FarmV3LiquidityChartDto>(
    `${API_FARMS_LIST}/${farmId}${API_FARMS_POOL_V3_LIQUIDITY_CHART}`,
  );

export const useLiquidityChartData = (farmId: number) =>
  useQuery<FarmV3LiquidityChartDto>({
    queryKey: [
      `${API_FARMS_LIST}/${farmId}${API_FARMS_POOL_V3_LIQUIDITY_CHART}`,
      farmId,
    ],
    queryFn: () => getLiquidityChartData(farmId),
    retry: false,
    enabled: !!farmId,
  });
